import { NgModule } from '@angular/core';
import { LogoUrlPipe } from './logo-url.pipe';

@NgModule({
    declarations: [LogoUrlPipe],
    exports: [LogoUrlPipe],
})
export class LogoUrlPipeModule {}
